import { render, staticRenderFns } from "./goals-table.vue?vue&type=template&id=090999de&scoped=true&"
import script from "./goals-table.vue?vue&type=script&lang=js&"
export * from "./goals-table.vue?vue&type=script&lang=js&"
import style0 from "./goals-table.vue?vue&type=style&index=0&id=090999de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090999de",
  null
  
)

export default component.exports